import * as loglevel from 'loglevel'
import  { isProduction } from '../config/constants'

if (!isProduction) {
  loglevel.setLevel('debug')
} else {
  loglevel.setLevel('error')
}

export default loglevel



// WEBPACK FOOTER //
// ./src/helpers/logger.js